import React, { Component } from 'react';
import { SpotlightsSection } from './SpotlightsStyles';
import { createIndustriesArray } from '../../services/clientSpotlightService';
import ClientSpotlightCard from '../ClientSpotlightCard/ClientSpotlightCard';

class SpotlightsComponent extends Component {
  state = {
    currentIndustry: 'All',
    industries: createIndustriesArray(this.props.clients),
    clients: this.props.clients,
  };

  getIndustrySpotlights(industry) {
    if (industry === 'All') {
      return this.props.clients;
    }
    const allClients = this.props.clients;
    const clients = allClients.filter(client => client.industry === industry);
    return clients;
  }

  switchIndustry = industry => {
    const clients = this.getIndustrySpotlights(industry);
    this.setState({
      currentIndustry: industry,
      clients,
    });
  };

  render() {

    return (
      <SpotlightsSection>
        <div className="container" data-component="cs-content">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              <ul className="industries">
                <li
                  className={this.state.currentIndustry === 'All' && 'active'}
                  data-component="cs-industry"
                >
                  <button
                    type="button"
                    className="link-style"
                    onClick={() => {
                      this.switchIndustry('All');
                    }}
                  >
                    All
                  </button>
                </li>
                {this.state.industries.map(industry => (
                  <li
                    key={industry}
                    className={this.state.currentIndustry === industry && 'active'}
                    data-component="cs-industry"
                  >
                    <button
                      type="button"
                      className="link-style"
                      onClick={() => {
                        this.switchIndustry(industry);
                      }}
                    >
                      {industry}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="spotlights">
            <div className="row">
              {this.state.clients.map(client => (
                <div className="col-sm-6 col-lg-4" key={client.small_image.url}>
                  <ClientSpotlightCard client={client} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </SpotlightsSection>
    );
  }
}

export default SpotlightsComponent;
